import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DxValidatorComponent } from 'devextreme-angular';
import { ComplianceRenewalFrequencyModel } from 'src/app/models/compliance/compliance-renewal-frequency.model';
import { CourseTemplateDateModel } from 'src/app/models/course/course-template-date.model';

@Component({
  selector: 'app-compliance-course-date-selection',
  standalone: false,
  templateUrl: './compliance-course-date-selection.component.html',
  styleUrl: './compliance-course-date-selection.component.scss',
})
export class ComplianceCourseDateSelectionComponent implements OnInit {
  @ViewChild('startDateValidator', { static: false }) 
  startDateValidator!: DxValidatorComponent;

  @ViewChild('endDateValidator', { static: false }) 
  endDateValidator!: DxValidatorComponent;

  @Input()
  readOnly: boolean = false;
  
  @Input()
  startDate: Date | null = null;

  @Input()
  endDate: Date | null = null;

  @Input()
  renewalFrequency!: ComplianceRenewalFrequencyModel;

  ComplianceRenewalFrequency = ComplianceRenewalFrequencyModel;

  ngOnInit(): void {
    this.updateEndDate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['renewalFrequency'] || changes['startDate']) {
      this.updateEndDate();
    }
  }

  private updateEndDate(): void {
    this.startDate ??= new Date();
    this.assignEndDate(this.startDate);
  }

  assignEndDate(startDate: Date) {
    if(this.readOnly && this.endDate) return;

    switch (this.renewalFrequency) {
      case ComplianceRenewalFrequencyModel.Never: 
        this.endDate = new Date(9999, 11, 31); // max date - 31.12.9999
        break;
      case ComplianceRenewalFrequencyModel.ThreeMonths:
      case ComplianceRenewalFrequencyModel.SixMonths:
      case ComplianceRenewalFrequencyModel.OneYear:
      case ComplianceRenewalFrequencyModel.TwoYears:
      case ComplianceRenewalFrequencyModel.ThreeYears: {
        this.endDate = new Date(startDate);
        const monthsToAdd = this.renewalFrequency as number;
        this.endDate.setMonth(this.endDate.getMonth() + monthsToAdd);
        this.endDate.setDate(this.endDate.getDate() - 1); // subtract 1 day
        break;
      }
      default:  
        console.error('Unknown renewal frequency:', this.renewalFrequency);
        throw new Error('Invalid renewal frequency selected.');
    }
  }

  public validateDates() {
    const isStartDateValid = this.startDateValidator.instance.validate().isValid;

    const isEndDateValid = !this.endDateValidator 
      || this.endDateValidator.instance.validate().isValid;

    return isStartDateValid && isEndDateValid;
  }

  public getDate(): CourseTemplateDateModel {
    return {
      start: this.startDate!,
      end: this.endDate!
    }
  }

  onStartDateChange(e: any) {
    this.startDate = e.value;
    if (this.startDate) {
      this.assignEndDate(this.startDate);
    }
  }
}

